import {
  API_ADMIN_CURRENT,
  API_ADMIN_PROFILE,
  API_GET_AUTHENTICATION,
  API_LOGIN,
  API_MERCHANT_PROFILE,
} from 'src/common/constants/apis';
import axios from 'src/common/utils/axios';
import { IAuth, IResInfo, IResLogin } from './interface';

export const getAuth = (params: IAuth): Promise<IResLogin> => {
  return axios.post(API_LOGIN, params);
};

export const getAuthInfo = (): Promise<any> => {
  return axios.get(API_GET_AUTHENTICATION);
};

export const getLogout = () => {
  return axios.delete('merchant/auth/logout');
};

export const getMerchantInfo = (): Promise<IResInfo> => {
  return axios.get(API_MERCHANT_PROFILE);
};

export const getAdminInfo = (): Promise<any> => {
  return axios.get(API_ADMIN_PROFILE);
};

export const getPolicesUser = () => {
  return axios.get<unknown, any>(API_ADMIN_CURRENT);
};
